module.exports = __webpack_public_path__ + "static/poligono1_03-cb2ead2f53b22c3f18b3b65a27bf1cc6.jpg";